export class SetProgress {
  static readonly type = '[Engine Progress] Set Progress';
  constructor(public storyLoadProgress: number, public chunkLoadProgress: number) { }
}

export class ResetProgress {
  static readonly type = '[Engine Progress] Reset Progress';
  constructor() { }
}
